export const LEAGUES_WITH_DURATIONS = {
  COD: 'COD',
  CS2: 'CS2',
  MLBLIVE: 'MLBLIVE',
  TENNISLIVE: 'TENNIS LIVE',
  MLB: 'MLB'
};
export const LEAGUES_WITH_DISPLAY_TIME = [
  'COD',
  'CS2',
  'APEX',
  'VAL',
  'LOL',
  'RL',
  'HALO',
  'Dota2',
  'R6'
];

export const LEAGUES_WITH_RELATED_DURATIONS = ['COD', 'CS2', 'MLBLIVE'];
